import { GoabFormItem, GoabCheckbox } from "@abgov/react-components";

export const Declaration = ({ form, getResourceValue, handleChange, markerPosition, selectedAddress }) => {
    const declarationError = form.errors.acceptDeclaration && form.touched.acceptDeclaration && getResourceValue({ key: form.errors.acceptDeclaration });
    
    return (
        <GoabFormItem
            requirement="required"
            id="acceptDeclaration"
            error={declarationError}
        >
            <GoabCheckbox
                name="acceptDeclaration"
                text={getResourceValue({ key: "RESOURCES@form.acceptAddressDeclaration.label" })}
                mt="xl"
                mb="none"
                disabled={!selectedAddress}
                checked={form.values.acceptDeclaration}
                error={declarationError}
                onChange={({name, value, checked}) => handleChange(form, name, checked)}
            />
        </GoabFormItem>
    );
};